module.exports = __webpack_public_path__ + "assets/img/3371-qa.svg";